import { render, staticRenderFns } from "./mgcPop2.vue?vue&type=template&id=3cf2962f&scoped=true"
import script from "./mgcPop2.vue?vue&type=script&lang=js"
export * from "./mgcPop2.vue?vue&type=script&lang=js"
import style0 from "./mgcPop2.vue?vue&type=style&index=0&id=3cf2962f&prod&lang=scss&scoped=true"
import style1 from "./mgcPop2.vue?vue&type=style&index=1&id=3cf2962f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf2962f",
  null
  
)

export default component.exports